import React from 'react';

const DisabledWrapper = ({
  disabled,
  children,
}: {
  disabled: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div className="position-relative">
      <div className={disabled ? 'opacity-50' : ''}>{children}</div>
      {disabled && <div className="position-absolute top-0 start-0 w-100 h-100" />}
    </div>
  );
};

export default DisabledWrapper;
